export const schedule = {
  go: {
    start: "Empezar",
    cantNow: "Ahora no puedo",
    details: "Detalles",
  },
notFound: "Programación no encontrada",
loadError: {
title: "No se pudo cargar esta programación",
description: "Comprueba tu conexión y vuelve a intentarlo.",
},
startFailed: "No se puede iniciar esta inspección.",
starting: "Iniciando...",
loadingAsset: "Cargando activo…",
breadcrumb: {
backToRequest: "← Volver a la solicitud",
scheduledInspection: "Inspección programada",
},
calendarInvite: {
titleWithAsset: "Inspección: {{asset}}",
titleFallbackAsset: "Activo",
descriptionChecklist: "Lista de verificación: {{name}}",
addToCalendar: "Añadir al calendario",
notNow: "Ahora no",
confirmedTitle: "Fecha confirmada",
confirmedBody: "El equipo ha sido notificado. ¿Añadir la visita a su calendario?",
},
sourceRequest: {
title: "Desde petición",
fallback: "Esta inspección programada sigue vinculada al historial de la solicitud de origen.",
openRequest: "Abrir solicitud",
},
visit: {
label: "Visita",
confirmed: "Confirmado por contacto",
awaitingConfirmation: "Esperando confirmación de contacto",
},
readOnlyAssetNotice: "Este activo se comparte con usted como de solo lectura, por lo que no se puede iniciar una inspección en él. Solicite a su propietario acceso de edición o ejecute esta inspección desde un activo de su propio espacio de trabajo.",
reschedule: {
accessibilityLabel: "Reprogramar inspección",
label: "Reprogramar",
},
changeRequest: {
sent: "Solicitud enviada",
savedOffline: "Guardado en este dispositivo — se enviará cuando vuelva a estar en línea",
sendFailed: "No se pudo enviar la solicitud",
decideFailed: "No se pudo registrar la decisión",
photosNeedSignal: "Las fotos necesitan señal para subirse. Quítelas para guardar esta solicitud sin conexión, o inténtelo de nuevo cuando vuelva a estar en línea.",
},
overflow: {
moreActionsLabel: "Más acciones de programación",
sheetTitle: "Opciones de programación",
},
status: {
  skipped: "Omitida",
upcoming: "Próxima",
due: "Vence ahora",
overdue: "Atrasada",
completed: "Completada",
cancelled: "Cancelada",
},
alerts: {
errorTitle: "Error",
templateMissing: "No se encontró la lista de control de lista de verificación.",
cancelTitle: "Cancelar programación",
cancelMessage: "¿Seguro que quieres cancelar esta inspección programada?",
cancelConfirm: "Cancelar programación",
no: "No",
deleteTitle: "Eliminar programación",
deleteMessage: "Se eliminará permanentemente esta programación.",
deleteConfirm: "Eliminar",
},
labels: {
asset: "Activo",
checklist: "Lista de verificación",
assignedTo: "Asignado a",
unassigned: "Sin asignar",
recurrence: "Se repite",
reminders: "Recordatorios",
none: "Ninguno",
seriesEndDate: "Fin de serie (fecha)",
seriesEndTime: "Fin de serie (hora)",
maxCompletedRuns: "Se detiene tras",
},
seriesEnd: {
sectionTitle: "Límites de serie (opcional)",
helper: "Déjelo en blanco para sin límite. La serie termina al alcanzar cualquier límite.",
maxPlaceholder: "p. ej. 12",
errors: {
maxPositive: "Introduzca un entero ≥ 1 o deje el campo vacío.",
invalidEnd: "La fecha u hora de fin no son válidas.",
endBeforeStart: "El fin de serie debe ser en o después del inicio programado.",
},
},
detail: {
  stopRepeat: {
    failed: "No se pudo detener la repetición. Compruebe la conexión e inténtelo de nuevo.",
    done: "Esta inspección ya no se repite.",
    confirm: "Dejar de repetir",
    message: "Esta visita se mantiene. No se crearán más visitas después.",
    title: "¿Dejar de repetir esta inspección?",
    action: "Dejar de repetir",
  },
seriesEnds: "Fin de la repetición",
maxRuns_one: "Se detiene tras {{count}} visita",
maxRuns_many: "Se detiene tras {{count}} visitas",
maxRuns_other: "Se detiene tras {{count}} visitas",
unlimitedRuns: "Sin límite",
noEndDate: "Sin fecha de fin",
},
list: {
untilDate: "Hasta {{date}}",
maxRunsChip_one: "Hasta {{count}} visita",
maxRunsChip_many: "Hasta {{count}} visitas",
maxRunsChip_other: "Hasta {{count}} visitas",
typeInspection: "Inspección",
typeJob: "Orden de trabajo",
filterActive: "Activo",
filterPast: "Pasado",
filterAll: "Todo",
overdueChip: "Vencido",
scheduleWork: "Programar trabajo",
scheduleSheetTitle: "¿Qué quieres programar?",
emptyTitle: "Nada programado",
emptyActiveSubtitle: "Programa una inspección o un trabajo y aparecerá aquí.",
emptyPastSubtitle: "No hay trabajo programado pasado.",
emptyAllSubtitle: "Aún no hay trabajo programado.",
},
unknownAsset: "Activo desconocido",
unknownChecklist: "Lista de verificación desconocida",
templateMeta_one: "{{count}} elemento · {{category}}",
templateMeta_other: "{{count}} elementos · {{category}}",
recurrence: {
none: "Puntual",
hourly: "Cada hora",
daily: "Cada día",
weekly: "Cada semana",
biweekly: "Cada 2 semanas",
monthly: "Cada mes",
quarterly: "Cada 3 meses",
yearly: "Cada año",
},
reminder: {
at_time: "A la hora programada",
"15min": "15 minutos antes",
"30min": "30 minutos antes",
"1hr": "1 hora antes",
"2hr": "2 horas antes",
"1day": "1 día antes",
"2day": "2 días antes",
},
actions: {
startNow: "Iniciar inspección ahora",
startFor: "Iniciar para {{name}}",
cancelSchedule: "Cancelar programación",
viewInspection: "Ver inspección",
delete: "Eliminar",
},
planner: {
subtitle: "Elige una fecha, asigna a una persona y fíjalo.",
scheduleCta: "Programar",
scheduleInspection: "Programar inspección",
scheduleJob: "Programar orden de trabajo",
},
create: {
createChecklistCta: "Crear lista de verificación",
noChecklistsHint: "Aún no hay listas de verificación. Cree una para seguir programando.",
overlayReturnFootnote: "Se abre en superposición. Al guardar, vuelve aquí con la lista de verificación seleccionada.",
ctaAccessibility: "Crear lista de verificación y volver a programar",
},
templateMeta_many: "{{count}} elementos · {{category}}",
};
